module.exports = new __parcel__URL__("cal.efcc29bc.png").toString();